module.exports = __webpack_public_path__ + "img/gilly-segal.4d0a1ebd.png";